import React, { useEffect } from "react";
import { useAppDispatch, RootState } from "./reduxStore";
import { useSelector } from "react-redux";
import { LoadingState } from "./state/loadingState";
import { fetchUserGroups } from "./state/userGroups";
import { Unauthorized } from "./pages/Unauthorized";
import { Loading } from "./pages/Loading";
import { Route, Switch } from "react-router-dom";
import AddBatch from "./pages/AddBatch";
import ListBatches from "./pages/ListBatches";
import Home from "./pages/Home";

function Main(): JSX.Element {
  const dispatch = useAppDispatch();
  const userGroupsLoading = useSelector((state: RootState) => state.userGroups.loading);
  const userGroups = useSelector((state: any) => state.userGroups.userGroups);
  const isUserGroupsLoading = userGroupsLoading === LoadingState.Pending;
  const hasValidUserGroups = userGroups.length > 0;

  useEffect(() => {
    if (userGroupsLoading === LoadingState.Succeeded) return;
    dispatch(fetchUserGroups());
  }, [userGroupsLoading, dispatch]);

  if (!hasValidUserGroups) return <Unauthorized />;
  if (isUserGroupsLoading) return <Loading />;

  return (
    <Switch>
      <Route path="/add">
        <AddBatch />
      </Route>
      <Route path="/list">
        <ListBatches />
      </Route>
      <Route exact path="/" component={Home} />
      <Route path="*" component={ListBatches} />
    </Switch>
  );
}

export default Main;
